import { DnsRecordType } from "@redotech/crdb-enums/dns/dns-record-type";
import { DnsSurface } from "@redotech/crdb-enums/dns/dns-surface";
import * as z from "zod";

/**
 * Records that a merchant launched a provisioner, and returns exactly what we
 * recorded as requested — the caller hands that to the provisioner unchanged.
 */
export const beginDnsAttempt = {
  name: "beginDnsAttempt" as const,
  input: z.object({
    domain: z.string(),
    /** Whose flow they were in, for reporting and for the failure's next step. */
    initiatedBy: z.enum(DnsSurface),
    /**
     * Which choice they made, or "either" to hand the provisioner both sets
     * and let it pick against the registrar it can actually see.
     */
    path: z.union([
      z.literal("direct"),
      z.literal("delegated"),
      z.literal("either"),
    ]),
  }),
  /**
   * The requested list is evidence a late callback is matched against, so the
   * server derives it rather than trusting a caller's idea of what we asked for.
   */
  output: z.object({
    requested: z.array(
      z.object({
        host: z.string(),
        type: z.enum(DnsRecordType),
        values: z.array(z.string()),
        adding: z.array(z.string()),
        ttlSeconds: z.number(),
        required: z.boolean(),
        /** Which arrangement it belongs to, so "either" stays separable. */
        appliesTo: z
          .union([
            z.literal("direct"),
            z.literal("delegated"),
            z.literal("both"),
          ])
          .optional(),
      }),
    ),
  }),
};
